import { render, staticRenderFns } from "./priceIndex.vue?vue&type=template&id=4e4d9765&scoped=true"
import script from "./priceIndex.vue?vue&type=script&lang=js"
export * from "./priceIndex.vue?vue&type=script&lang=js"
import style0 from "./priceIndex.vue?vue&type=style&index=0&id=4e4d9765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4d9765",
  null
  
)

export default component.exports